module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.content.title,
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.form,
      "rules": _vm.fields.validation
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "title",
      "label": "Titre"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Saisissez le titre de votre tâche"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "description",
      "label": "Description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "Saisissez la description de votre tâche"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "task_list",
      "label": "Session de travail"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    model: {
      value: (_vm.selectedTaskList),
      callback: function($$v) {
        _vm.selectedTaskList = $$v
      },
      expression: "selectedTaskList"
    }
  }, _vm._l((_vm.tasklists), function(tasklist) {
    return _c('el-option', {
      key: tasklist.id,
      attrs: {
        "label": tasklist.name,
        "value": tasklist.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.form.id !== null) ? _c('el-button', {
    directives: [{
      name: "delete",
      rawName: "v-delete:task",
      value: (this.form),
      expression: "this.form",
      arg: "task"
    }],
    staticClass: "pull-left",
    attrs: {
      "type": "danger",
      "plain": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Supprimer")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.content.button_type
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.content.button))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fbdb1c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/TaskModal.vue
// module id = 681
// module chunks = 1